import { rest } from 'utils';

export default {
  getAll: () => rest.get({ baseUrl: 'certificateManager', url: '/certificates' }),
  create: ({ properties }) => rest.post({ baseUrl: 'certificateManager', url: '/certificates', body: { properties } }),
  get: ({ id }) => rest.get({ baseUrl: 'certificateManager', url: `/certificates/${id}` }),
  delete: ({ id }) => rest.delete({ baseUrl: 'certificateManager', url: `/certificates/${id}` }),
};
